var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"svg-button",class:{
    'disabled': _vm.disabled
  },on:{"mouseover":function($event){(!_vm.hovered ? _vm.hover(true) : null)},"mouseleave":function($event){return _vm.hover(false)},"click":_vm.clicked}},[_c('div',{staticClass:"center-block",attrs:{"title":_vm.toolTipText}},[(_vm.icon)?_c('p4a-icon',{staticClass:"svg-image",style:({
        'width': _vm.size.width,
        'height': _vm.size.height,
        'transform': 'rotate(' + _vm.rotation + 'turn)'
      }),attrs:{"slot":"face","icon":_vm.iconData,"color":_vm.svgColor},slot:"face"}):_vm._e(),_vm._v(" "),(_vm.text)?_c('label',{staticClass:"button-label",style:({ 'color': _vm.textColor }),domProps:{"textContent":_vm._s(_vm.text)}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49efeeda","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ButtonTemplates/SvgButton.vue
// module id = null
// module chunks = 